import React, { useState } from "react";
import {
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    Button,
    Tooltip,
    SearchBox,
    InputOnChangeData,
    tokens,
    TagGroup,
    Tag,
    TagGroupProps,
    Caption1,
    Link,
} from "@fluentui/react-components";
import { makeStyles } from "@fluentui/react-components";
import { SelectableTree } from "./SelectableTree";
import { TreeNode } from "./SelectableTree";
import { getPlanningCategoryTree } from "../../redux/Actions/PowerDataQuery";
import { FolderRegular } from "@fluentui/react-icons";

const useClasses = makeStyles({
    surface: {
        minWidth: '45%',
    },
    moreBtn: {
        minWidth: 0,
        padding: '0px 10px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    main: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '10px',
        height: '300px',
    },
    tags: {
        width: '360px',
        height: 'calc(100% - 10px)',
        overflow: 'auto',
        borderRadius: tokens.borderRadiusMedium,
        border: '1px dotted gray',
        padding: '5px',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
    },
    tree: {
        width: '60%',
        height: '100%',
        overflow: 'auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    search: {
        width: '55%',
        display: 'flex',
        gap: '10px',
        marginBottom: "5px"
    },
    input: {
        flex: 1,
    },
    helper: {
        color: 'gray',
    },
    linkText: {
        fontSize: '12px',
    },
});

interface IPrimaryProductsPopupProps {
    onProductsChange: (products: TreeNode[]) => void;
    defaultProducts: TreeNode[];
    isOpen: boolean;
    closeProductsPopup: (value) => void;
}

export const PrimaryProductsPopup = (props: IPrimaryProductsPopupProps): React.JSX.Element => {
    const classes = useClasses();
    const [inputValue, setInputValue] = React.useState('');
    const [searchValue, setSearchValue] = React.useState('');
    const [visibleTags, setVisibleTags] = React.useState<TreeNode[]>(props.defaultProducts);
    // const [isOpen, setIsOpen] = React.useState(false);
    const [productList, setProductList] = React.useState<TreeNode[]>([]);
    const [isLoadingProducts, setIsLoadingProducts] = React.useState(true);
    // const thirdPartService = useThirdPartCall();

    const [PlanningCategory, setPlanningCategory] = useState<string>("")
    const [PlanningCategoryGroup, setPlanningCategoryGroup] = useState<string>("")
    const [PlanningCategoryBusiness, setPlanningCategoryBusiness] = useState<string>("")

    type AlertAction = { type: "SHOW_ALERT", payload: string };
    const alertReducer = (_state: any, action: AlertAction) => {
        if (action.type === "SHOW_ALERT") {
            alert(action.payload);
        }
        return _state;
    };
    const [_, dispatch] = React.useReducer(alertReducer, null);

    React.useEffect(() => {
        (async () => {
            setIsLoadingProducts(true);
            try {
                getPlanningCategoryTree().then(res => {
                    if (res.Success) {
                        setProductList(res.Result || []);
                    }
                })
                
                setVisibleTags(props.defaultProducts || []);
                if (props.defaultProducts != null && props.defaultProducts.length > 0) {
                    var str = props.defaultProducts[0].tagName.split("/");
                    setPlanningCategory(str[0])
                    setPlanningCategoryGroup(str[1])
                    setPlanningCategoryBusiness(str[2])
                }
            } catch (error) {
                dispatch({
                    type: "SHOW_ALERT",
                    payload: error.message || "Get primary products failed, please close this dialog and reopen."
                });
            } finally {
                setIsLoadingProducts(false);
            }
        })();
    }, [props.defaultProducts]);

    const debouncedSetSearchValue = React.useCallback((value: string) => {
        debugger
        setSearchValue(value)}, []);

    const changeInputValue = (_: any, data: InputOnChangeData) => {
        debugger
        setInputValue(data.value);
        debouncedSetSearchValue(data.value);
    };

    const onTagAdd = React.useCallback((item: TreeNode) => {
        if (visibleTags.every(tag => tag.Key !== item.Key)) {
            // setVisibleTags([...visibleTags, item]);

            setVisibleTags([item]);
            var str = item.tagName.split("/");
            setPlanningCategory(str[0])
            setPlanningCategoryGroup(str[1])
            setPlanningCategoryBusiness(str[2])
        }
    }, [visibleTags]);

    const onTagRemove: TagGroupProps["onDismiss"] = (_, data) => {
        setVisibleTags(visibleTags.filter(tag => tag.Key !== data.value));
    };

    const saveProducts = () => {
        props.onProductsChange(visibleTags);
    };

    const cancelClick = () => {
        if (props.defaultProducts.length === 0) {
            setVisibleTags([]);
        }
    };

    const openChangeCallback = (_: any, data: any) => {
        // setIsOpen(data?.open);
        props.closeProductsPopup(false)
    };

    return (
        <Dialog open={props.isOpen} onOpenChange={openChangeCallback}>
            <DialogTrigger disableButtonEnhancement>
                <Tooltip content="Click to open" relationship="label" positioning="before">
                    <Button className={classes.moreBtn}>...</Button>
                </Tooltip>
            </DialogTrigger>
            <DialogSurface className={classes.surface}>
                <DialogBody>
                    <DialogTitle>Assign a Planning Category (PCY)</DialogTitle>
                    <DialogContent>
                        
                        {
                            visibleTags.length > 0 ?
                                <div className="breadcrumb-wrapper" style={{ marginBottom: "15px", marginTop: "5px" }}>
                                    <FolderRegular className="breadcrumb-icon" />
                                    <span className="breadcrumb-text">
                                        <span className="prefix">PCY:</span>
                                        <span className="breadcrumb-item">
                                            {PlanningCategory}
                                        </span>
                                        <span className="separator">{'>'}</span>
                                        <span className="breadcrumb-item">
                                            {PlanningCategoryGroup}
                                        </span>
                                        <span className="separator">{'>'}</span>
                                        <span className="breadcrumb-item">
                                            {PlanningCategoryBusiness}
                                        </span>
                                    </span>
                                </div> : null
                        }

                        <div className={classes.content}>
                            <div className={classes.header}>
                                <div className={classes.search}>
                                    <SearchBox
                                        size="medium"
                                        placeholder="Search for a PCY by name"
                                        className={classes.input}
                                        value={inputValue}
                                        onChange={changeInputValue}
                                    />
                                </div>
                                {/* <Caption1 className={classes.helper}>
                                    Can't find your product?{" "}
                                    <Link
                                        className={classes.linkText}
                                        href="https://aka.ms/Osezhk"
                                        target="_blank"
                                        rel="noreferrer"
                                        inline
                                    >
                                        File a bug here
                                    </Link>.
                                </Caption1> */}
                            </div>
                            <div className={classes.main}>
                                <div className={classes.tree}>
                                    <SelectableTree
                                        treeData={productList}
                                        onItemAdd={onTagAdd}
                                        filterText={searchValue}
                                        isLoading={isLoadingProducts}
                                    />
                                </div>
                                <TagGroup
                                    // onDismiss={onTagRemove}
                                    aria-label="Selected primary products"
                                    size="small"
                                    className={classes.tags}
                                >
                                    {visibleTags.map(tag => (
                                        <Tag
                                            // dismissible
                                            // dismissIcon={{ "aria-label": "remove" }}
                                            value={tag.Key}
                                            key={tag.Key}
                                        >
                                            {tag.tagName}
                                        </Tag>
                                    ))}
                                </TagGroup>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary" onClick={cancelClick}>Cancel</Button>
                        </DialogTrigger>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="primary" onClick={saveProducts}>Save</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};
